import { Box, Grid, Alert, Typography, CircularProgress } from '@mui/material'
import { BarChart } from '@mui/x-charts'
import type { FC } from 'react'

import type { TimeInterval } from '@/utils/dateRange'

import type { DataPoint } from './types'
import { sortDataPoints, toXAxisLabel } from './utils'

export type Props = {
  errorMessage?: string
  loading?: boolean
  data?: DataPoint[]
  timeInterval: TimeInterval
}

const height = 300

const DateTotalsGraph: FC<Props> = ({
  data = [],
  errorMessage,
  loading = false,
  timeInterval,
}) => (
  <Box sx={{ height }}>
    {errorMessage ? (
      <Alert severity="error">
        <Typography variant="body2">{errorMessage}</Typography>
      </Alert>
    ) : loading ? (
      <Grid container sx={{ height, alignItems: 'center', justifyContent: 'center' }}>
        <span data-testid="activity-graph-loading">
          <CircularProgress />
        </span>
      </Grid>
    ) : data.length === 0 ? (
      <Alert severity="info">
        <Typography variant="body2">No results were found.</Typography>
      </Alert>
    ) : (
      <BarChart
        dataset={data.sort(sortDataPoints)}
        xAxis={[
          {
            scaleType: 'band',
            dataKey: 'date',
            valueFormatter: date => toXAxisLabel(date, timeInterval),
          },
        ]}
        series={[
          {
            dataKey: 'total',
            label: 'Total',
          },
        ]}
        slotProps={{
          legend: {
            hidden: true,
          },
        }}
        height={height}
      />
    )}
  </Box>
)

export default DateTotalsGraph
